import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { LoadingService } from '@sharedServices/loading.service';

/**
 * Component for displaying a loading spinner.
 */
@Component({
  selector: 'app-loading',
  imports: [MatProgressSpinner, AsyncPipe],
  templateUrl: './loading.html',
  styleUrl: './loading.scss',
})
export class Loading {
  /**
   * The loading service to control the visibility of the spinner.
   */
  loadingService = inject(LoadingService);
}
